enum AccessReportsWizardCalculationMethodEnum {
  Unknown = 0,
  Distance = 1,
  Time = 2,
  TimeAndDistance = 3,
  TimeOrDistance = 4,
}

export { AccessReportsWizardCalculationMethodEnum };
